import { render, staticRenderFns } from "./ProjectEconomySupplierValues.vue?vue&type=template&id=39d0797c&scoped=true&"
import script from "./ProjectEconomySupplierValues.vue?vue&type=script&lang=js&"
export * from "./ProjectEconomySupplierValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d0797c",
  null
  
)

export default component.exports